import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { Fold, Traversal } from "@discovery/prelude/lib/control/lens";
import { _ImageGetter, _ImagesGetter, } from "@discovery/sonic-api-ng-optics-gen/lib/image";
export * from "@discovery/sonic-api-ng-optics-gen/lib/image";
export const _ImageOfKind = (kind) => Fold.compose(_ImageGetter, Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === kind));
export const _ImagesOfKind = (kind) => Fold.compose(_ImagesGetter, Res._ForEach(), Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === kind));

